import Service from "@/utils/api/service";
import Multiselect from "vue-multiselect";
import { mapState } from "vuex";
import { loadMasterData } from "@/utils/loadMasterData";

export default {
  name: "CreateDeliveryFeeDisctrict",
  data() {
    return {
      isFetching: true,
      isCreating: false,
      body: {
        branchId: null,
        provinceId: null,
        districtId: null,
        distance: 0,
        description: "",
      },
      loading: {
        isCreating: false,
        isSearching: false,
        isProvincing: false,
        isDistricting: false,
      },
      payload: {},
      options: {
        branchs: "",
        provinces: "",
        districts: "",
      },
      districts: [],
      provinces: [],
    };
  },
  components: {
    Multiselect,
  },
  computed: {
    ...mapState(["permissions"]),
  },
  created() {
    setTimeout(async () => {
      await this.getDetail();
      await this.getProvinces();
    }, 500);
  },
  methods: {
    goBack() {
      this.$router.push({
        name: "ListDeliveryFeeDistrict",
      });
    },

    checkoutPermission(permissionName) {
      if (this.permissions) {
        let result = false;
        this.permissions.find((item) => {
          item.permissions.find((permission) => {
            if (permission.name == permissionName) {
              result = true;
            }
          });
        });

        return result;
      }
    },

    isNumber(e) {
      const key = e.key;
      const value = e.target.value;

      // Allow navigation/editing keys
      if (
        ["Backspace", "Delete", "ArrowLeft", "ArrowRight", "Tab"].includes(key)
      ) {
        return;
      }

      // Allow shortcuts
      if (
        (e.ctrlKey || e.metaKey) &&
        ["a", "c", "v", "x"].includes(key.toLowerCase())
      ) {
        return;
      }

      // Enforce max 30 chars
      if (value.length >= 30 && !["Backspace", "Delete"].includes(key)) {
        e.preventDefault();
        return;
      }

      // Allow digits
      if (/^\d$/.test(key)) return;

      // Allow one decimal point (not at start, not multiple)
      if (key === "." && value.length > 0 && !value.includes(".")) {
        return;
      }

      // Otherwise block
      e.preventDefault();
    },

    handlePaste(e) {
      const pasted = (e.clipboardData || window.clipboardData).getData("text");

      // Only allow numbers with optional single decimal
      if (!/^\d+(\.\d+)?$/.test(pasted)) {
        e.preventDefault();
        return;
      }
    },

    onSelectProvince() {
      this.options.districts = "";

      if (this.options?.provinces?.id) {
        this.getDistricts();
      }
    },

    async getProvinces() {
      let params = "?all=true&countryId=1";
      this.loading.isProvincing = true;

      await Service.getProvince(params).then((response) => {
        this.loading.isProvincing = false;
        this.isFetching = false;

        if (response?.statusCode) {
          if (response?.statusCode === "4410") {
            Service.refreshToken().then((response) => {
              if (response === "ok") {
                this.getDistricts();
              }
            });
          } else {
            this.$toasted.show(response?.message);
          }
        } else {
          this.provinces = response?.data;
        }
      });
    },

    async getDistricts() {
      let params = `?all=true&provinceId=${this.options.provinces?.id}`;
      this.loading.isDistricting = true;

      await Service.getDistrict(params).then((response) => {
        this.loading.isDistricting = false;

        if (response?.statusCode) {
          if (response?.statusCode === "4410") {
            Service.refreshToken().then((response) => {
              if (response === "ok") {
                this.getDistricts();
              }
            });
          } else {
            this.$toasted.show(response?.message);
          }
        } else {
          this.districts = response?.data;
        }
      });
    },

    async getDetail() {
      setTimeout(() => {
        // this.isFetching = false;
      }, 500);
    },

    onSubmit() {
      let validatedMessage = this.validateBody(this.body);

      if (validatedMessage == "ok") {
        this.isCreating = true;
        this.onConfirm();
      } else {
        this.$toasted.show(validatedMessage);
      }
    },

    validateBody(data) {
      if (!this.options.branchs?.id) {
        return "Branch cannot be empty!";
      } else if (!this.options.provinces?.id) {
        return "City / Province cannot be empty!";
      } else if (!this.options.districts?.id) {
        return "District cannot be empty!";
      } else if (typeof data.distance === "string" || data.distance < 0) {
        return "Distance cannot be empty or smaller than zero!";
      }

      return "ok";
    },

    transformBody(originalBody) {
      const transformedBody = { ...originalBody };
      transformedBody.branchId = this.options.branchs?.id;
      transformedBody.provinceId = this.options.provinces?.id;
      transformedBody.districtId = this.options.districts?.id;
      // transformedBody.districtIds = (originalBody.districtIds ?? []).map(
      //   (district) => district.id
      // );
      // transformedBody.customerGroupIds = (
      //   originalBody.customerGroupIds ?? []
      // ).map((group) => group.id);
      // transformedBody.customerIds = (originalBody.customerIds ?? []).map(
      //   (customer) => customer.id
      // );

      return transformedBody;
    },

    onConfirm() {
      Service.createDeliveryFeeDistrict(this.transformBody(this.body)).then(
        (response) => {
          if (response.statusCode) {
            if (response.statusCode == "4410") {
              Service.refreshToken().then((response) => {
                if (response == "ok") {
                  this.onConfirm();
                }
              });
            } else {
              this.isCreating = false;
              this.$toasted.show(response.message);
            }
          } else {
            this.isCreating = false;
            this.$toasted.show("Delivery District has been updated.");
            loadMasterData();
            this.goBack();
          }
        }
      );
    },

    resetBody() {
      this.body = {
        branchId: null,
        provinceId: null,
        districtId: null,
        distance: 0,
        description: "",
      };
    },
  },
};
